module.exports = __webpack_public_path__ + "static/yarl_storvald-316ccf5313078a1f3e3de2597ec82555.jpg";